import type { SVGProps } from "react";

export default function TrashIcon(props: Readonly<SVGProps<SVGSVGElement>>) {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.99998 2.29199C9.18456 2.29199 8.48923 2.81285 8.23154 3.54193C8.1165 3.86738 7.75943 4.03797 7.43398 3.92293C7.10853 3.8079 6.93795 3.45083 7.05299 3.12538C7.48168 1.91248 8.6384 1.04199 9.99998 1.04199C11.3616 1.04199 12.5183 1.91248 12.9471 3.12538C13.0621 3.45083 12.8915 3.8079 12.5661 3.92293C12.2406 4.03797 11.8835 3.86738 11.7685 3.54193C11.5108 2.81285 10.8154 2.29199 9.99998 2.29199Z"
        fill="currentColor"
      />
      <path
        d="M2.2915 5C2.2915 4.65483 2.57133 4.375 2.9165 4.375H17.0833C17.4284 4.375 17.7083 4.65483 17.7083 5C17.7083 5.34517 17.4284 5.625 17.0833 5.625H2.9165C2.57133 5.625 2.2915 5.34517 2.2915 5Z"
        fill="currentColor"
      />
      <path
        d="M4.9293 7.04146C4.90634 6.69704 4.60852 6.43646 4.26411 6.45942C3.9197 6.48237 3.65911 6.78019 3.68207 7.12461L4.06828 12.9177C4.13952 13.9867 4.19707 14.8501 4.33205 15.5277C4.47238 16.2321 4.71106 16.8205 5.20406 17.2817C5.69706 17.7429 6.30001 17.9419 7.01222 18.0351C7.69726 18.1247 8.56265 18.1247 9.63398 18.1247H10.3663C11.4376 18.1247 12.303 18.1247 12.9881 18.0351C13.7002 17.9419 14.3032 17.7429 14.7962 17.2817C15.2892 16.8205 15.5279 16.2321 15.6682 15.5277C15.8031 14.8501 15.8607 13.9867 15.932 12.9177L16.3182 7.12461C16.3411 6.78019 16.0806 6.48237 15.7361 6.45942C15.3917 6.43646 15.0939 6.69704 15.071 7.04146L14.6876 12.7907C14.6128 13.9139 14.5594 14.6954 14.4423 15.2834C14.3286 15.8539 14.1701 16.1558 13.9422 16.3689C13.7144 16.582 13.4026 16.7203 12.8259 16.7957C12.2314 16.8734 11.4481 16.8747 10.3224 16.8747H9.6779C8.55223 16.8747 7.76886 16.8734 7.17436 16.7957C6.59769 16.7203 6.28589 16.582 6.05804 16.3689C5.8302 16.1558 5.67159 15.8539 5.55796 15.2834C5.44082 14.6954 5.38746 13.9139 5.31259 12.7907L4.9293 7.04146Z"
        fill="currentColor"
      />
      <path
        d="M7.85436 8.54514C8.19783 8.51081 8.50406 8.76139 8.53848 9.10489L8.95514 13.2716C8.98948 13.615 8.7389 13.9213 8.3954 13.9556C8.05195 13.99 7.74566 13.7394 7.71132 13.3959L7.29465 9.22922C7.2603 8.88581 7.51089 8.57947 7.85436 8.54514Z"
        fill="currentColor"
      />
      <path
        d="M12.7051 9.22922C12.7395 8.88581 12.4889 8.57947 12.1454 8.54514C11.802 8.51081 11.4957 8.76139 11.4613 9.10489L11.0447 13.2716C11.0103 13.615 11.2609 13.9213 11.6044 13.9556C11.9478 13.99 12.2541 13.7394 12.2885 13.3959L12.7051 9.22922Z"
        fill="currentColor"
      />
    </svg>
  );
}
